import { Modal } from "../../Components/Dialog/Modal";

class LanguageDialog extends Modal {
    constructor(contentId: string) {
        super(contentId);
        this.dialog.classList.add(contentId);
    }
}

const langSelect = document.querySelector(".header-icon.lang-select");

if (langSelect) {
    langSelect.addEventListener("click", () => {
        new LanguageDialog("lang-select").render();
    });
}
